import { FunctionComponent } from 'react';
import FlexibleContentTile from './FlexibleContentTile';
import './NoDataTile.scss';

interface INoDataTile {
  colSplit: number;
  messageLeft: string;
  messageRight: string;
}

//this is intentionally a separate interface - scoping issues occured otherwise
//receives rich text from api and used by each tab
export interface INoDataTileMessage {
  leftText: string;
  rightText: string;
}

export const GetNoDataTile = async (
  type: string,
  setNoDataTile: React.Dispatch<React.SetStateAction<INoDataTileMessage>>,
) => {
  let noDataTile: INoDataTileMessage;
  fetch(`api/sitecore/PageContentAsync/GetRecentActivitiesTabRichText`, {
    method: 'POST',
    body: new URLSearchParams({ type: type }),
  })
    .then((res) => res.json())
    .then((res) => {
      noDataTile = res as INoDataTileMessage;
      setNoDataTile(noDataTile);
    })
    .catch(() => {
      setNoDataTile({
        leftText: `<div>No insights right now.</div>
                  <br />
                  <div>Something went wrong</div>`,
        rightText: `<div>No insights right now.</div>
                    <br />
                    <div>Something went wrong</div>`,
      });
    });
};

const RecentActivitiesNoData: FunctionComponent<any> = (props: INoDataTile) => {
  return (
    <>
      <FlexibleContentTile
        isContentTile={true}
        children={[
          <div className="recent-activities-no-data-left">
            <div
              className="recent-activities-no-data-inner"
              dangerouslySetInnerHTML={{ __html: props.messageLeft }}
            ></div>
          </div>,

          <div
            className="recent-activities-no-data-right"
            dangerouslySetInnerHTML={{ __html: props.messageRight }}
          ></div>,
        ]}
      ></FlexibleContentTile>
    </>
  );
};

export default RecentActivitiesNoData;
